import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { FeaturedCollections } from '../components/home/FeaturedCollections';
import { BuildYourStack } from '../components/home/BuildYourStack';
import { FounderTeaser } from '../components/home/FounderTeaser';
import { SocialBanner } from '../components/home/SocialBanner';
import { MarqueeStripe } from '../components/ui/MarqueeStripe';
export function HomePage() {
  return <div className="flex flex-col w-full" data-id="element-334">
      <HeroSection data-id="element-335" />
      <MarqueeStripe data-id="element-336" />
      <FeaturedCollections data-id="element-337" />
      <BuildYourStack data-id="element-338" />
      <FounderTeaser data-id="element-339" />
      <SocialBanner data-id="element-340" />
    </div>;
}